module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 163
// module chunks = 0